export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    return;
  }

  const store = usePreferenceStore();

  const isUnderMaintenance = store.preference.general.maintenance;
  const isMaintenanceRoute = to.name === 'maintenance';

  if (isUnderMaintenance && !isMaintenanceRoute) {
    return navigateTo({ name: 'maintenance' });
  }

  if (!isUnderMaintenance && isMaintenanceRoute) {
    return navigateTo({ name: 'index' });
  }
});
